<template>
  <div style="height: 100%;">
    <div style="height: 100%;" class="modal-SeeDoctorRecords">
      <el-form :model="addForm" ref="addForm" :rules="rules" :disabled='disabled'>
        <el-row>

          <el-card class="box-card" shadow='never'>

            <div slot="header" class="clearfix">
              <span>就诊信息</span>
            </div>

            <el-col :span="24" >
                <el-col :span="8" class="item" >
                  <el-form-item label="就诊医院" required prop="hospital">
                      <el-input v-model="addForm.hospital" clearable placeholder="请输入就诊医院"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8" class="item" >
                  <el-form-item label="就诊科室" required prop="department">
                      <el-input v-model="addForm.department" clearable placeholder="请输入就诊科室"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="item" >
                  <el-form-item label="医生" required prop="doctor">
                    <el-input v-model="addForm.doctor" clearable placeholder="请输入就诊医生"></el-input>
                  </el-form-item>
                </el-col>
            </el-col>
            <el-col :span="8" class="item" style="margin-top:20px" >
              <el-form-item label="就诊时间" required prop="seeDoctorTime">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="addForm.seeDoctorTime"
                  type="date"
                  placeholder="选择日期"
                  style="width:100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="item" style="margin-top:20px">
              <el-form-item label="复诊时间" prop="furtherTime">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="addForm.furtherTime"
                  type="date"
                  placeholder="选择日期"
                  style="width:100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-card>

          <el-card class="box-card" shadow='never'>
            <div slot="header" class="clearfix">
              <span>就诊信息</span>
            </div>

            <el-col :span="12" class="item" >
              <el-form-item label="主诉内容" prop="chiefComplaint">
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入主诉内容"
                  v-model="addForm.chiefComplaint"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item" >
              <el-form-item label="体格检查内容" prop="physicalExamination">
                <el-input
                  type="textarea"
                  clearable
                  :rows="5"
                  placeholder="请输入体格检查内容"
                  v-model="addForm.physicalExamination"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item" clearable >
              <el-form-item label="辅助检查内容" prop="auxiliaryExamination">
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入辅助检查内容"
                  v-model="addForm.auxiliaryExamination"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item" clearable >
              <el-form-item label="实际检查内容" prop="realityExamination">
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入实际检查内容"
                  v-model="addForm.realityExamination"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item" clearable >
              <el-form-item label="正在使用药物" prop="useMedication">
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入正在使用药物"
                  v-model="addForm.useMedication"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item" clearable >
              <el-form-item label="本次诊断结果" prop="diagnosisResults">
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入本次诊断结果"
                  v-model="addForm.diagnosisResults"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item" clearable >
              <el-form-item label="治疗处方和保健处方" prop="treatmentPrescription">
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入治疗处方和保健处方"
                  v-model="addForm.treatmentPrescription"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item" clearable >
              <el-form-item label="相关禁忌事项" prop="aboutTaboo">
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入相关禁忌事项"
                  v-model="addForm.aboutTaboo"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-card>
        </el-row>
      </el-form>

      <div style="background-color: white;height: 80px; width: 100% " v-show="!disabled">
        <div style="margin-left: 43.5%;margin-top: 10px; ">
          <el-button type="primary" style="width: 26%" @click="confirm('addForm')">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { timeStr } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import { getStaffCode } from "@/utils/auth";

export default {
  name: "Role",
  data() {
    return {
      elderlyName: "",
      elderlyPhone:"",
      disabled: false,
      addForm: {
        timeStr: timeStr,
        staffCode: getStaffCode(),
        sign: "",
        userCode: "",
        elderlyCode: "",
        hospital: "",
        department: "",
        doctor: "",
        seeDoctorTime: "",
        furtherTime: "",
        chiefComplaint: "",
        physicalExamination: "",
        realityExamination: "",
        auxiliaryExamination: "",
        useMedication: "",
        diagnosisResults: "",
        treatmentPrescription: "",
        aboutTaboo: "",
      },
      rules: {
        hospital: [
          { required: true, message: "请输入医院名称", trigger: "blur" },
        ],
        department: [
          { required: true, message: "请输入就诊科室", trigger: "blur" },
        ],
        doctor: [
          { required: true, message: "请输入就诊医生", trigger: "blur" },
        ],
        seeDoctorTime: [
          { required: true, message: "请选择就诊时间", trigger: "blur" },
        ],
      },
    };
  },
  created() {},
  components: {},
  watch: {
    //监听全局变量
    "$store.state.tableHeight": function () {},
  },
  methods: {
    init(flag, row,disabled) {
      if(disabled)this.disabled=disabled
      this.$refs.addForm.resetFields();
      this.addForm.elderlyCode = row.elderlyCode;
      this.addForm.userCode = row.userCode;
      //this.getElderlyInfo();
      if (flag) {
        this.getSeeDoctorRecord();
      }
    },
    confirm(addForm) {
      this.$refs[addForm].validate((valid) => {
        if (valid) {
          this.addSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addSubmit() {
      if (this.loading) {
        return;
      } else {
        this.loading = true;
      }
      this.addForm.sign = hex_md5(
        "timeStr=" + timeStr + "&key=" + this.$signKey
      );
      this.$axios({
        method: "post",
        url: this.$shopUrl + "ESeeDoctorRecord/Add",
        data: this.addForm,
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      });
    },
    getSeeDoctorRecord() {
      this.addForm.sign = hex_md5(
        "timeStr=" + timeStr + "&key=" + this.$signKey
      );
      this.$axios({
        method: "post",
        url: this.$shopUrl + "ESeeDoctorRecord/GetByElderlyCode",
        data: this.addForm,
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
            if (response.data.data != null) {
              this.addForm.hospital = response.data.data.hospital;
              this.addForm.department = response.data.data.department;
              this.addForm.doctor = response.data.data.doctor;
              this.addForm.chiefComplaint = response.data.data.chiefComplaint;
              this.addForm.physicalExamination = response.data.data.physicalExamination;
              this.addForm.auxiliaryExamination = response.data.data.auxiliaryExamination;
              this.addForm.realityExamination = response.data.data.realityExamination;
              this.addForm.useMedication = response.data.data.useMedication;
              this.addForm.diagnosisResults = response.data.data.diagnosisResults;
              this.addForm.treatmentPrescription = response.data.data.treatmentPrescription;
              this.addForm.aboutTaboo = response.data.data.aboutTaboo;
              this.addForm.seeDoctorTime=response.data.data.seeDoctorTime.substring(0,10)
              this.addForm.furtherTime=response.data.data.furtherTime.substring(0,10)
            }
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getElderlyInfo() {
      this.addForm.sign = hex_md5(
        "timeStr=" + timeStr + "&key=" + this.$signKey
      );
      this.$axios({
        method: "post",
        url: this.$shopUrl + "ESeeDoctorRecord/GetElderlyInfo",
        data: this.addForm,
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
            if (response.data.data != null) {
              this.elderlyName=response.data.data.elderlyName;
              this.elderlyPhone=response.data.data.elderlyPhone;
            }
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-SeeDoctorRecords {
  /deep/ .el-textarea.is-disabled .el-textarea__inner {
        background-color: #fff;
        border-color: #DCDFE6;
        color: #606266;
        cursor: not-allowed;
    }
  /deep/ .el-input.is-disabled .el-input__inner {
      background-color: #fff;
      border-color: #DCDFE6;
      color: #606266;
      cursor: not-allowed;
  }
  /deep/ .el-card {
      border-top:0;
  }
  .item{
    padding: 0 10px;
  }
}
</style>
